import { render, staticRenderFns } from "./CreateWarehouseModal.vue?vue&type=template&id=58a838f4&scoped=true&"
import script from "./CreateWarehouseModal.vue?vue&type=script&lang=js&"
export * from "./CreateWarehouseModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateWarehouseModal.vue?vue&type=style&index=0&id=58a838f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a838f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58a838f4')) {
      api.createRecord('58a838f4', component.options)
    } else {
      api.reload('58a838f4', component.options)
    }
    module.hot.accept("./CreateWarehouseModal.vue?vue&type=template&id=58a838f4&scoped=true&", function () {
      api.rerender('58a838f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Warehouses/Modals/CreateWarehouseModal.vue"
export default component.exports